import { BooleanIdentity, LogicalAnd, LogicalNAnd, LogicalNOr, LogicalNot, LogicalOr, LogicalXNor, LogicalXOr, NaturalAdd, NaturalDivide, NaturalDouble, NaturalIdentity, NaturalLessThan, NaturalMultiply, NaturalSubtract, } from './_pure/tools.js';
export const TOOL_IMPLEMENTATION_BY_NAME = {
    BooleanIdentity,
    LogicalAnd,
    LogicalNAnd,
    LogicalOr,
    LogicalNOr,
    LogicalXOr,
    LogicalXNor,
    LogicalNot,
    NaturalIdentity,
    NaturalLessThan,
    NaturalAdd,
    NaturalSubtract,
    NaturalMultiply,
    NaturalDivide,
    NaturalDouble,
};
export const TOOL_INVOCATION_BY_HANDLE = {
    // Template selector tools are intentionally excluded from runtime invocation.
    'TOOL-BooleanIdentity': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: BooleanIdentity,
    },
    'TOOL-LogicalAnd': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalAnd,
    },
    'TOOL-LogicalNAnd': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalNAnd,
    },
    'TOOL-LogicalOr': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalOr,
    },
    'TOOL-LogicalNOr': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalNOr,
    },
    'TOOL-LogicalXOr': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalXOr,
    },
    'TOOL-LogicalXNor': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalXNor,
    },
    'TOOL-LogicalNot': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: LogicalNot,
    },
    'TOOL-NaturalIdentity': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalIdentity,
    },
    'TOOL-NaturalLessThan': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalLessThan,
    },
    'TOOL-NaturalAdd': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalAdd,
    },
    'TOOL-NaturalSubtract': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalSubtract,
    },
    'TOOL-NaturalMultiply': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalMultiply,
    },
    'TOOL-NaturalDivide': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalDivide,
    },
    'TOOL-NaturalDouble': {
        invocationKind: 'local',
        inputMode: 'projection',
        outputMode: 'projection',
        invoke: NaturalDouble,
    },
};
